export default "/_next/static/fonts/25dfa139e95be4dd4a0d33b951def478.woff";